
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`این مطلب توسط پروژه
                    <a href="${0}">موتور فولکسونومی</a>ارائه شده است.
                    در مشارکت یا ارائه بازخورد دریغ نکنید.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`این ابزار به شما امکان می‌دهد لیست مواد تشکیل دهنده را اصلاح کنید. می‌توانید لیست مواد تشکیل دهنده
                را اضافه، حذف یا ویرایش کنید.
                <br>
                این کاراکتر <span class="highlight">␣</span> نشان دهنده یک فاصله است.
                <br>
                این کاراکتر <span class="highlight">↩︎</span> نشان دهنده یک شکست خط است. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `در حال بارگذاری ویژگی‌ها...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `برای تهیه مواد اولیه به ما کمک کنید`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `اعتبارسنجی برش`,
's03e9c8114521b998': `مواد لازم را ویرایش می‌کنم`,
's05ec315d9308091a': `آیکون گوشه‌های بارکد`,
's061eb5af92512c85': `ذخیره شد! میشه یکی دیگه رو هم کمک کنی؟`,
's06847c221c4c0bc1': `من می‌خواهم یک ویژگی برای [توصیف مورد استفاده شما] ایجاد کنم...`,
's06f6c6f99db6b552': `اصلی`,
's081e2ad82db71e1d': `مقادیر گروه‌بندی‌شده`,
's09205907b5b56cda': `خير`,
's0b4235aae602a950': `مستندات اختصاصی`,
's0bb2d48532acc455': `دانلود CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `تصویر نامعتبر`,
's100c4928cc74642a': `حمایت از پیشرفت تحقیقات در حوزه سلامت عمومی`,
's10db5498186c083b': `لغو برش`,
's11a18a69b30b65ed': `به ما در رفع خطاهای موجود در لیست مواد تشکیل دهنده کمک کنید`,
's1205d5f6fccf8e69': `ارزش ملک`,
's15d64a0a6715285a': `کلید جدید`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `منطقه انتخاب`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `به ما در اصلاح اطلاعات تغذیه‌ای کمک کنید`,
's1e00019dc454872d': `لطفا با استفاده از ویژگی property-name نام ویژگی را وارد کنید.`,
's1e49126af0935a5b': `لیست محصولاتی که از این ویژگی استفاده می‌کنند`,
's21e73088de6f26f3': `دانلود از اپ استور`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `سند ملک را تهیه کنید`,
's300b3a6ee4e1252d': str`تطابق ضعیف ${0}%`,
's33f786bb6b4f0cf4': `نتیجه برش`,
's33f85f24c0f5f008': `ذخيره`,
's34be4af4e8fec4ae': `اول از جامعه بپرسید`,
's36d86adc823cbfa6': `قبل از ایجاد یک ملک جدید، آن را با جامعه در میان بگذارید:`,
's3781d25aa51a736c': `مستندات موتور فولکسونومی`,
's383ae4449428b61e': `تنظیم مجدد برش`,
's39bcf88721a1e8ee': `تنظیم مجدد انتخاب`,
's39e14e14300694c7': `مستندات و دستورالعمل‌ها`,
's3b430cfa5c1fe7f4': str`مستندات مربوط به ${0}`,
's3f4e4b52f230a892': `بوم تصویر`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `تصویر مرکز`,
's42dd66b2441566fd': `آیکون مرکز`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `تغییر اندازه به راست`,
's475b08749d0706ed': `به ما کمک کنید تا میلیون‌ها مصرف‌کننده در سراسر جهان را در مورد آنچه می‌خورند آگاه کنیم`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `تعداد محصول`,
's4df2f533c0c1e7d0': `کنترل‌های تصویر`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `انتخاب را حرکت دهید`,
's4f751fb9b3ed766c': `ایجاد یک ملک جدید`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `نام ملک را وارد کنید...`,
's55d7249883a98ca1': `درباره این ملک در ویکی حقایق غذایی آزاد`,
's565867d84c04aea2': `ویژگی‌های فیلتر ...`,
's5666afe5cd0166de': `لطفاً قبل از تأیید، خطاها را برطرف کنید یا متن را تغییر دهید`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `در حال بارگیری محصولات...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `به ما در اصلاح اطلاعات تغذیه‌ای کمک کنید.`,
's5dd6f12783fca34f': `ویرایش لیست مواد تشکیل دهنده`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `من حمایت می‌کنم`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `تصویر برش خورده`,
's6d7b6cdedaadfb6e': `هر کمک مالی ارزشمند است! ما از حمایت شما در ایجاد شفافیت بیشتر در زمینه مواد غذایی در جهان قدردانی می‌کنیم.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`تطابق خوب ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `مستندات`,
's787dd11bed0dc88a': `تغییر اندازه سمت چپ`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `درباره ایجاد ملک و دستورالعمل‌ها بیشتر بدانید:`,
's8038273de2cf8b73': `لطفا یک منطقه برای برش انتخاب کنید.`,
's839cc2908a5387f2': `فیلتر کردن بارکدها ...`,
's86197dcf3e96af64': `مرور و جستجوی املاک موجود`,
's8a63be30a129a59c': `تغییر اندازه پایین`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `تغییر اندازه بالا سمت راست`,
's8db84aa4bc949af2': `ملک جدید را مستند کنید`,
's8f839a03997a16d7': `مشاهده محصول`,
's901ae1e236ac45d3': `لغو حذف`,
's907f7a97c6b29425': `توجه داشته باشید که مدل داده ممکن است تغییر کند. با مسئولیت خودتان استفاده کنید.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `مواد لازم:`,
's9a7f60fce090ecaf': `بارگیری ویژگی‌ها ناموفق بود. لطفاً بعداً دوباره امتحان کنید.`,
's9b87abd68fb9df45': `پیدا نشد؟ کلید جدید ایجاد کنید {value}`,
's9c0f52425fd2f07e': `ممکن است مطابقت نداشته باشد`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `امتیازی موجود نیست`,
'sa548778b24054030': `تمام ویژگی‌های ارائه شده از پروژه Folksonomy Engine را کاوش کنید. این ویژگی‌ها، فراداده‌ها و بینش‌های بیشتری در مورد محصولات موجود در پایگاه داده Open Food Facts ارائه می‌دهند.`,
'sa63907958bd0ec4b': `تغییر اندازه بالا سمت چپ`,
'sa95b4224f685a36a': `بستن مودال`,
'sab56a1d439576fd6': `نماد پیشنهاد`,
'sac47ea2901d04c15': `تغییر اندازه پایین سمت چپ`,
'sb125227d436c2925': `مفهوم ملک خود را در پایگاه داده املاک موجود جستجو کنید:`,
'sb125568d43642e6f': `به سوالات مربوط به محصول پاسخ دهید.`,
'sb1c538e038f9b214': str`تطابق خیلی خوب ${0}%`,
'sb28639570ff3b852': `لیست تمام املاک`,
'sb3bdd638a58d30f4': `مشارکت دادن جامعه‌ای از شهروندان متعهد،`,
'sb3cbcc1bd0fff140': `وقتی تأیید کردید که ملک شما وجود ندارد و جامعه موافق مفید بودن آن است، ابتدا باید آن را در ویکی مستند کنید.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `محصولی برای این ملک یافت نشد.`,
'sb7f72e4c8a2d3357': `فیلتر کردن مقادیر...`,
'sb8178320160f84ea': `نمایش برش`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `به همه بینش‌ها پاسخ داده شده است! از کمک شما متشکرم!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `مقدار متناظر`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `تغییر اندازه بالا`,
'sc1c08d0cbcc3bd24': `مطابقت ندارد`,
'sc52696641af72b53': `برنامه را نصب کنید!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `راه حل پیشنهادی`,
'sc681b137e8f604f7': `تایید حذف`,
'sc6daf8a31883f8b9': `تصویر را جابجا کنید`,
'sc895972c88d38ca5': `خاصیت فولکسونومی`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `ردیف‌ها`,
'scb3b0671d7b7f640': `ارزش جدید`,
'scb489a1a173ac3f0': `بلی`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `به بحث Slack بپیوندید`,
'scdb6cad0b92721bf': `هیچ ملکی یافت نشد.`,
'scf23a05631f93732': `تأیید حذف`,
'scfed2f270ef6a3aa': `انتخاب منطقه`,
'sd1022bc1ef9204f7': `تصویر قابل بزرگنمایی`,
'sd1077c055cf9ba6b': `به ما در تأیید لیست مواد تشکیل دهنده محصول کمک کنید.`,
'sd698d21ddecba56b': `سلام! شما می‌توانید با پاسخ دادن به بخش‌های زیر به ما در بهبود اطلاعات محصول کمک کنید:`,
'sd82bc2decefa621b': `مستقل ماندن از صنایع غذایی،`,
'sdb97e5976482606e': `بررسی کنید که آیا یک ویژگی از قبل وجود دارد یا خیر`,
'sdbf806fefc584115': `شما باید یک`,
'sdc673e73b5c13aea': `Delet`,
'sdc792b75f1edcaba': `به ما در اصلاح املای مواد تشکیل دهنده کمک کنید.`,
'sdca5deead576ceee': `تغییر اندازه پایین سمت راست`,
'sdcc2555c5dde524f': `آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟ این اقدام قابل بازگشت نیست.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `باطل کردن`,
'se5127cf0f92e7e48': `نکته: شما همچنین می‌توانید موارد زیر را پیدا کنید`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `من یک محصول بهتر پیشنهاد خواهم داد`,
'seea3800e27baa686': `محصولات تکی`,
'sefaba4adc4ec9219': `ویژگی‌های فولکسونومی`,
'seffa8ca49175b5f0': `املاک شخصی‌سازی‌شده`,
'sf44a6b3b232c28ea': str`مقدار فعلی را با ${0}جایگزین کنید`,
'sf4cd86a2f5ef2588': `بارکد محصول`,
'sf57a61152168cc81': `به ما در اصلاح تشخیص مواد تشکیل دهنده کمک کنید`,
'sf88b90b8ba23871c': `تطابق ناشناخته`,
'sf9aee319a006c9b4': `افزودن`,
'sfacbbe968fa7d773': `نام ملک:`,
'sfc40ea3d5d5aa6f8': `کمک‌های مالی شما، هزینه‌های روزمره‌ی انجمن غیرانتفاعی ما را تأمین می‌کند:`,
'sfe87465d50530725': `مقدار مربوطه`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  